import { useState } from "react";
import { updateItems } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const filters = ["全部", "电视剧", "电影", "国漫", "综艺", "纪录片"];

export default function UpdateGrid() {
  const [filter, setFilter] = useState("全部");

  const list =
    filter === "全部" ? updateItems : updateItems.filter((item) => item.category === filter);

  return (
    <section id="updates" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="01"
          title="今日更新 · 持续上新"
          subtitle="电影、电视剧、国漫与综艺实时入库，随点随看不用等"
          actionLabel="查看全部更新"
          actionHref="#updates"
        />

        <div className="no-scrollbar mb-5 flex gap-2 overflow-x-auto pb-1">
          {filters.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setFilter(item)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                filter === item
                  ? "bg-foreground-950 font-medium text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-6">
          {list.map((item) => (
            <a key={item.id} href="#updates" className="group block">
              <div className="relative mb-2 aspect-[3/4] overflow-hidden rounded-lg bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 免费在线观看 - 久久视频高清影视`}
                  title={`${item.title} - ${item.category}高清资源`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/0 transition-colors group-hover:bg-foreground-950/40"></div>
                <span className="absolute left-2 top-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[11px] text-background-50">
                  {item.category}
                </span>
                <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded bg-accent-500 px-1.5 py-0.5 font-heading text-[11px] text-foreground-950">
                  <i className="ri-star-fill text-[10px]"></i>
                  {item.score}
                </span>
                <span className="absolute inset-0 flex items-center justify-center text-4xl text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-play-circle-fill"></i>
                </span>
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent px-2 pb-1.5 pt-6 text-[11px] text-background-100">
                  {item.episode}
                </span>
              </div>
              <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-700">
                {item.title}
              </h3>
              <div className="mt-1 flex items-center justify-between text-[11px] text-foreground-500">
                <span className="truncate">{item.tags.join(" · ")}</span>
                <span className="shrink-0">{item.time}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}